import { useModuleSettings } from "./useModuleSettings";
import { ReactNode } from "react";

/**
 * Hook to conditionally render components based on module status
 */
export const useConditionalModules = () => {
  const { isModuleEnabled, isLoading } = useModuleSettings();

  const withModule = (moduleName: string, component: ReactNode): ReactNode | null => {
    if (isLoading) return null;
    return isModuleEnabled(moduleName) ? component : null;
  };

  return {
    isModuleEnabled,
    isLoading,
    withModule,
    // Specific module checks
    isEthicsEnabled: () => isModuleEnabled("ethics_compliance"),
    isEquipmentEnabled: () => isModuleEnabled("equipment_management"),
    isSupplierEvaluationsEnabled: () => isModuleEnabled("supplier_evaluations"),
  };
};
